import { ILayout } from '@/types/serverLayout.type'

export class Layout {
  xl: number
  lg: number
  md: number
  sm: number
  useCol: boolean
  useRow: boolean
  visible: boolean

  constructor (layout: ILayout) {
    this.xl = layout?.xl || 12
    this.lg = layout?.l || 12
    this.md = layout?.m || 12
    this.sm = layout?.s || 12
    this.useCol = layout?.useCol || false
    this.useRow = layout?.useRow || false
    this.visible = layout?.visible !== false
  }
}
